import { SETTINGS_SCOPE } from 'utils/settings';

export const PREFERENCES_GROUP_ID = 'preferences';

export const SETTINGS_GROUPS = [
    {
        id: 'account',
        labelKey: 'settings.account-title',
        fallback: 'Account',
        icon: 'avatar',
        sections: [
            { id: 'edit-profile', labelKey: 'settings.sections.edit-profile', fallback: 'Edit Profile' },
            {
                id: 'interface-language',
                labelKey: 'settings.sections.interface-language',
                fallback: 'Interface Language',
            },
        ],
    },
    {
        id: 'course-settings',
        labelKey: 'course-settings.title',
        fallback: 'Course Settings',
        icon: 'settings',
        instructorOnly: true,
        requiresCourse: true,
        sections: [{ id: 'course-details', labelKey: 'settings.sections.course-details', fallback: 'Course Details' }],
    },
    {
        id: 'preferences',
        labelKey: 'preferences.title',
        fallback: 'Preferences',
        icon: 'wrench',
        instructorOnly: true,
        sections: [
            { id: 'grading', labelKey: 'settings.sections.grading', fallback: 'Grading' },
            { id: 'feedback', labelKey: 'settings.sections.feedback', fallback: 'Feedback' },
            {
                id: 'formative-feedback',
                labelKey: 'settings.sections.formative-feedback',
                fallback: 'Formative Feedback',
            },
            { id: 'inline-comments', labelKey: 'settings.sections.inline-comments', fallback: 'Inline Comments' },
        ],
    },
];

export const getVisibleSettingsGroups = ({ role, course, scope }) =>
    SETTINGS_GROUPS.filter(
        ({ id, instructorOnly, requiresCourse }) =>
            (scope !== SETTINGS_SCOPE.ACCOUNT || id === 'account') &&
            (!instructorOnly || role === 'instructor') &&
            (!requiresCourse || Boolean(course))
    );

export const flattenSettingsSections = (groups) => groups.flatMap(({ sections }) => sections);
